import { ActionTypes } from './actions';

const initialState = {
    detailsVisible: false,
};

export default function inNetworkInsuranceReducer(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.SHOW_INSURANCE_DETAILS:
            return {
                ...state,
                detailsVisible: true,
            };

        case ActionTypes.HIDE_INSURANCE_DETAILS:
            return {
                ...state,
                detailsVisible: false,
            };

        default:
            return state;
    }
}
